import React from 'react';
import classNames from 'classnames';

import MFormHeader from '../MFormHeader/MFormHeader';

import classes from './MFormContainer.module.scss';

type Props = {
  className?: string;
  headerClassName?: string;
  title?: string;
  headerActions?: JSX.Element | JSX.Element[] | null;
  headerJSX?: JSX.Element | JSX.Element[] | null;
  isFullScreen?: boolean;
  onBack?: () => void;
  onFullScreen?: () => void;
};

const MFormContainerView: React.FC<Props> = (props: React.PropsWithChildren<Props>) => {
  return (
    <div className={classNames(classes['container'], props.className)}>
      <MFormHeader
        className={props.headerClassName}
        title={props.title}
        headerActions={props.headerActions}
        isFullScreen={props.isFullScreen}
        onBack={props.onBack}
        onFullScreen={props.onFullScreen}
      >
        {props.headerJSX}
      </MFormHeader>
      {props.children}
    </div>
  );
};

MFormContainerView.displayName = 'MFormContainerView';

export default MFormContainerView;
